<template>
  <div class="common_bg explain" :class="{'posi':from==='home'}">
    <div class="law">
      <div class="title">
        <span>隐私政策</span>
        <span class="close cursor" v-if="from!=='home'" @click="close">撤回</span>
      </div>
      <div class="content">
        <iframe src="https://cdn.zhuhuotech.com/live/privacy.html" frameborder="0"></iframe>
      </div>
    </div>
    <Back @goBack="goBack"/>
    <alert
      :show="alertShow"
      sameTwo="撤回后需要重新同意隐私政策才能正常使用名师火箭班"
      cancal="确定撤回"
      btn="取消"
      @cancelEvent="loginOut"
      @ensure="alertShow=false"
    ></alert>
  </div>
</template>
<script>
import Back from "@/components/basic/back.vue";
import alert from '@/components/basic/alert.vue';
import { mapMutations } from "vuex";
import utils from 'utils';
import common from 'common';
export default {
  data(){
    return {
      alertShow:false
    }
  },
  components: {
    Back,
    alert
  },
  props:{
    from:{
      default:''
    }
  },
  methods: {
    ...mapMutations(["resetState", "clearTool"]),
    goBack() {
      if(this.from==='home'){
        this.$router.replace({
          path: "/"
        });
        return
      }
      this.$router.push("/userinfo");
    },
    close(){
      this.alertShow = true;
    },
    loginOut(){
      LIMI_ENV==='electron'?utils.setNodeStorge("privacyIsChecked", false):common.set("privacyIsChecked", false);
      this.resetState();
      window.sessionStorage.clear();
      this.$router.replace({
        path: "/"
      });
    }
  }
};
</script>
<style lang="less" scoped>
@bg-color: #0089ce;
.posi{
  position: absolute;
  z-index: 999;
  top: 0;
}
.contnet-common {
  width: 100%;
  height: 100%;
  padding-bottom: 60px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.explain {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: @bg-color;
    font-size: 26px;
    color: #fff;
    position: relative;
    margin-bottom: 15px;
  }
  .close{
    float: right;
    font-size: 20px;
    padding-right: 30px;
  }
  .law {
    .contnet-common;
  }
  .law .content {
    background: #fff;
    height: 100%;
    margin: 0 auto;
    width:1024px;
    overflow: hidden;
    border-radius: 20px;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/explain/explain.vue